module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_08-10de3fc623aee3d1b723bfb1bb6f7411.jpg";